import Router from 'vue-router';

export default {
  expose(Vue) {
    Vue.use(Router);
  },
};
